import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { AsyncSaveButton } from "./AsyncSaveButton";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { COUNTRIES } from "@/utils/countries";

const AddAirportDialog = ({ open, onOpenChange, airport, setAirport, onSave }) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle data-testid="add-airport-dialog-title">Add Custom Airport</DialogTitle>
          <DialogDescription>
            This airport wasn&apos;t found in our database. Please provide the details below.
          </DialogDescription>
        </DialogHeader>
        <div className="grid gap-4 py-4">
          <div className="grid gap-2">
            <Label htmlFor="airport-name">Airport Name *</Label>
            <Input
              id="airport-name"
              data-testid="airport-name-input"
              placeholder="e.g., John F. Kennedy International Airport"
              value={airport.name}
              onChange={(e) => setAirport({ ...airport, name: e.target.value })}
            />
          </div>
          <div className="grid gap-2">
            <Label htmlFor="airport-iata">IATA Code * (3 letters)</Label>
            <Input
              id="airport-iata"
              data-testid="airport-iata-input"
              placeholder="e.g., JFK"
              value={airport.iata}
              onChange={(e) => setAirport({ ...airport, iata: e.target.value.toUpperCase() })}
              maxLength={3}
            />
          </div>
          <div className="grid gap-2">
            <Label htmlFor="airport-city">City *</Label>
            <Input
              id="airport-city"
              data-testid="airport-city-input"
              placeholder="e.g., New York"
              value={airport.city}
              onChange={(e) => setAirport({ ...airport, city: e.target.value })}
            />
          </div>
          <div className="grid gap-2">
            <Label htmlFor="airport-country">Country *</Label>
            <Select value={airport.country} onValueChange={(value) => setAirport({ ...airport, country: value })}>
              <SelectTrigger id="airport-country" data-testid="airport-country-select">
                <SelectValue placeholder="Select a country..." />
              </SelectTrigger>
              <SelectContent position="popper" className="max-h-60">
                {COUNTRIES.map((country) => (
                  <SelectItem key={country} value={country}>
                    {country}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)} data-testid="airport-cancel-btn">
            Cancel
          </Button>
          <AsyncSaveButton onSave={onSave} className="bg-sky-500 hover:bg-sky-600" data-testid="airport-save-btn" savingLabel="Saving…">
            Save Airport
          </AsyncSaveButton>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default AddAirportDialog;
